import React from "react";
import Request from "./components/Request";

export default function Landing() {
  return (
    <div className="landing">
      <div className="landingIntro">
        <div className="landingIntro__image">
          <div className="landingIntro__top">
            <img src={process.env.PUBLIC_URL + "/images/top.png"} alt="top" />
          </div>
          <img
            className="landingIntro__img"
            src={process.env.PUBLIC_URL + "/images/landing.png"}
            alt="landing"
          />
          <div className="landingIntro__bot">
            <img src={process.env.PUBLIC_URL + "/images/bot.png"} alt="bot" />
          </div>
        </div>
        <div className="landingIntro__content">
          <div className="landingIntro__content-logo">
            <img src={process.env.PUBLIC_URL + "/images/logo.svg"} alt="logo" />
          </div>
          <h1>Enjoy our platform!</h1>
          <p className="xlg">
            Get paid in cryptocurrencies hassle-free with Paylink - simply
            connect your wallet and create multi-chain payment requests.
          </p>
          <a href="#" className="button primary">
            Connect Wallet
          </a>
        </div>
      </div>
      <div className="landingRequest">
        <Request />
      </div>
    </div>
  );
}
